import { render, staticRenderFns } from "./borrowedRecord.vue?vue&type=template&id=0632de2c&scoped=true"
import script from "./borrowedRecord.vue?vue&type=script&lang=js"
export * from "./borrowedRecord.vue?vue&type=script&lang=js"
import style0 from "./borrowedRecord.vue?vue&type=style&index=0&id=0632de2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0632de2c",
  null
  
)

export default component.exports